import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { Col, Row } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSettingGet } from '../../redux/slices/settingGetSlice'
import { fetchSettingUpdate } from '../../redux/slices/settingUpdateSlice'
import { toast } from 'react-toastify'
import FileUploader from './fileUploader'

const SettingsPage = () => {
    const { t } = useTranslation();
    const setting = useSelector((state => state.settingGet.data));
    const status = useSelector((state => state.settingGet.status));
    const dispatch = useDispatch();

    const getData = async () => {
        await dispatch(fetchSettingGet());
    };

    const handleLogoUpload = async (file) => {
        if (!file) return;
        try {
            await dispatch(fetchSettingUpdate({ file: [{ file: file }] }));
            toast.success(t("logo_updated_successfully"));
            getData();
        } catch (error) {
            toast.error(t("error_updating_logo"));
        }
    };

    const handleBannerUpload = async (file) => {
        if (!file) return;

        try {
            await dispatch(fetchSettingUpdate({ banner: [{ file: file }] }));
            toast.success(t("banner_updated_successfully"));
            getData();
        } catch (error) {
            toast.error(t("error_updating_banner"));
        }
    };

    const handleLogoSelect = (file) => {
        handleLogoUpload(file);
    };

    const handleBannerSelect = (file) => {
        handleBannerUpload(file);
    };

    useEffect(() => { getData() }, [dispatch]);

    return (
        <CMS>
            <PageBanner
                title={t("site_settings")}
                description={t("site_settings_desc")}
            />

            {status === "succeeded" && (
                <Row className="mt-4 g-3">
                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <FileUploader
                            title={t("logo")}
                            imageUrl={setting?.file ? setting.file : undefined}
                            onFileSelect={handleLogoSelect}
                        />
                    </Col>

                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <FileUploader
                            title={t("banner")}
                            imageUrl={setting?.banner ? setting.banner : undefined}
                            onFileSelect={handleBannerSelect}
                        />
                    </Col>
                </Row>
            )}
        </CMS>
    );
};

export default SettingsPage;